import React from 'react';
import { Game } from '@containers';

const App: React.FC = () => (
  <Game />
);

export default App;
